import {
  AttachmentsGallery,
  AttachmentsGalleryOptions
} from "core/classes/attachments/attachments.gallery.class";

let AttachmentsTableOption = function() {
  return $.extend({}, AttachmentsGalleryOptions, {
    attachmentClasses: {
      gallery: ".tables-attachments"
    },
    swiper: {
      noSwiping: true
    }
  });
};

class AttachmentsTable extends AttachmentsGallery {
  constructor(element, options) {
    super(element, AttachmentsTableOption());
    this.swiper.addNoSwipeClass();
    // Fix for firefox not calculating slides correctly
    var self = this;
    setTimeout(function() {}, self.options.initialSlideTimeout);
  }

  addMaxHeight() {}

  setupGalleryHoverButtons() {}
}

export { AttachmentsTable };



// WEBPACK FOOTER //
// ./Javascript/core/classes/attachments/attachments.table.class.js